import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { Countdown } from "./Countdown";
import { useProduct, eur } from "@/lib/product";

const NAV = [
  ["pourquoi", "Pourquoi maintenant"],
  ["avantages", "Avantages"],
  ["comparatif", "Comparatif"],
  ["installation", "Installation"],
  ["fiche-technique", "Fiche technique"],
  ["faq", "FAQ"],
];

export const Logo = () => (
  <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2.5 group">
    <span className="logo-mark" aria-hidden />
    <span className="flex flex-col leading-none">
      <span className="font-display text-xl font-extrabold tracking-tight text-slate-900">
        Clim<span className="text-sky-600">Nova</span>
      </span>
      <span className="text-[10px] font-medium tracking-[0.08em] text-slate-500 mt-0.5">par EAUVÈO</span>
    </span>
  </Link>
);

const UrgencyBanner = () => {
  const { product } = useProduct();
  if (!product?.promo_active) return null;
  return (
    <div data-testid="top-urgency-banner" className="urgency-banner">
      <Flame className="w-4 h-4 shrink-0 hidden sm:block" />
      <span className="hidden sm:inline">Offre de déstockage : {eur(product.promo_price)} (prix public conseillé <s>{eur(product.normal_price)}</s>) — fin dans</span>
      <span className="sm:hidden">Déstockage −{eur(product.normal_price - product.promo_price)} vs PPC · fin dans</span>
      <Countdown prefix="banner" compact />
    </div>
  );
};

export const Header = () => {
  const { product } = useProduct();
  return (
    <>
      <UrgencyBanner />
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/85 border-b border-slate-200/80">
        <div className="container-x flex items-center justify-between h-16">
          <Logo />
          <nav className="hidden lg:flex items-center gap-7">
            {NAV.map(([id, label]) => (
              <a key={id} href={`/#${id}`} data-testid={`navbar-link-${id}`} className="nav-link">
                {label}
              </a>
            ))}
          </nav>
          <a href="/#commander" data-testid="navbar-cta-button" className="btn-heat !py-2.5 !px-5 text-sm">
            Commander{product ? ` · ${eur(product.current_price)}` : ""}
          </a>
        </div>
      </header>
    </>
  );
};
